var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedoIcon = function SvgRedoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.667 7a5.333 5.333 0 0 1 9.104-3.771c.186.186.456.474.729.771H10a.667.667 0 0 0 0 1.333h3a.667.667 0 0 0 .667-.666v-3a.667.667 0 0 0-1.334 0v1.27c-.229-.248-.451-.483-.62-.651a6.667 6.667 0 1 0 0 9.428.667.667 0 1 0-.942-.942A5.32 5.32 0 0 1 7 12.333H7A5.333 5.333 0 0 1 1.667 7"
  })));
};
export default SvgRedoIcon;